import {FC} from "react";
import {CreateNewEntityForm} from "../../../CreateNewEntityForm";
import "../../../../create-hierarchy/steps/common/BuilderStep.scss";

export interface TestEntityFormStepProps {
  onCancel: () => void;
}

/**
 * First step of the CreateNewEntityStepper - wraps the existing CreateNewEntityForm
 * as a stepper step component. This integrates the form into the 3-step
 * workflow instead of using it as a standalone page.
 *
 * Uses TestEntity context for form data and validation state management.
 */
export const CreateNewEntityFormStep: FC<TestEntityFormStepProps> = ({
  onCancel
}) => {
  return (
    <section
      data-testid={"test-entity-form-step"}
      className={"hierarchy-builder-step test-entity-form-step"}>
      <CreateNewEntityForm onCancel={onCancel} />
    </section>
  );
};
